import { union, includes } from 'lodash';


export default class Filters {

    static NAMES = {
        GRAPH_TYPE: 'graphType',
        SECTOR: 'sector'
    }

    static filterByGraphType(type, links, nodes){
        if(!type) return [];

        // handle links
        const filteredLinks = links.filter(link=>link[type] == 1);

        // handle nodes
        let relatedNodeIds = [];
        filteredLinks.each(link => {
            relatedNodeIds = union(relatedNodeIds, [link.source.id, link.target.id]);
        });

        const filteredNodes = nodes.filter(node => includes(relatedNodeIds, node.id));

        return [
            filteredLinks,
            filteredNodes
        ];
    }

    static filterBySector(sector, links, nodes){
        // handle links
        const filteredLinks = links.filter(link=>link[sector] == 1);

        // handle nodes
        let relatedNodeIds = [];
        filteredLinks.each(link => {
            relatedNodeIds = union(relatedNodeIds, [link.source.id, link.target.id]);
        });

        const filteredNodes = nodes.filter(node => includes(relatedNodeIds, node.id));

        return [
            filteredLinks,
            filteredNodes
        ];
    }

    static filterNodesOfCategory(nodesOfCategory, category, nodeIdsToShow){
    
        if(!nodesOfCategory || nodesOfCategory.empty()){
            nodesOfCategory = this.d3.selectAll(`.node[category="${category.name}"]`);
        }
        
        if(nodeIdsToShow && Array.isArray(nodeIdsToShow) && nodeIdsToShow.length>0){
            nodesOfCategory = nodesOfCategory.filter(n => nodeIdsToShow.indexOf(n.id) !== -1)
        }

        // nodes
        nodesOfCategory.style('display', '');

        // links
        nodesOfCategory.each((node)=>{
            const sourceLinksToShow = this.d3.selectAll('.link')
            .filter(l=>{ // filter by source
                return l.source.id === node.id;
            })
            .filter(l=>{ // filter by "the target related node is visible"
                const targetNode = this.d3.select(`.node[id="${l.target.id}"]`);
                return targetNode.style('display') !== 'none';
            });
            sourceLinksToShow.style('display', '');

            const targetLinksToShow = this.d3.selectAll('.link')
            .filter(l=>{ // filter by target
                return l.target.id === node.id;
            })
            .filter(l=>{ // filter by "the source related node is visible"
                const sourceNode = this.d3.select(`.node[id="${l.source.id}"]`);
                return sourceNode.style('display') !== 'none';
            });
            targetLinksToShow.style('display', '');
        });
    }
}